// @ts-nocheck
import * as $ from 'jquery';
import Mediator from 'Common/Mediator';

enum NotificationType {
    Info = 0,
    Error = 1,
    Success = 2
}

const mediator = Mediator.instance;

class NotificationManager {
    private container: JQuery;

    constructor(private element: JQuery) {
        // register container where all notifications will be displayed
        this.container = element;

        // set up mediator subscriptions
        mediator.subscribe('notification:append', this.append, null, this);
        mediator.subscribe('notification:show', this.show, null, this);
    }

    /**
     * Appends a notification message to the container
     * @param message Message to display
     * @param type Notification type
     * @param scrollToTop
     */
    append(message: string, type: NotificationType, scrollToTop: boolean): void {
        const template = this.getTemplate(type);
        if (!template) {
            return;
        }
        const messageContainer = template.find('[data-notification-manager__message]');
        messageContainer.text(message);
        template.appendTo(this.container);

        if (scrollToTop) {
            this.scrollToNotification();
        }
    }

    getTemplate(type: NotificationType): JQuery {
        let style = 'info';
        let icon = 'info-circle';

        switch (type) {
        case NotificationType.Error:
            style = 'error';
            icon = 'bug-fill';
            break;
        case NotificationType.Success:
            style = 'success';
            icon = 'journal-check';
            break;
        }

        return $($.parseHTML(
            `<div class="alert alert-${style} alert-dismissible fade show" role="alert">
                <span class="bi bi-${icon}"></span>
                <span data-notification-manager__message></span> 
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>`));
    }

    /**
     * Empties the container before adding the notification
     * @param message Message to display
     * @param type Notification type
     * @param scrollToTop
     */
    show(message: string, type: NotificationType, scrollToTop: boolean): void {
        this.container.empty();
        this.append(message, type, scrollToTop);
    }

    scrollToNotification(): void {
        window.scrollTo(0, 0);
    }
}

$(() => {
    $('[data-notification-manager]').each((index, elem) => {
        const element = $(elem);
        if (!element.length) {
            return;
        }
        element.data('plugin_notificationManager', new NotificationManager(element));
    });
});

export {
    NotificationType
};
export default NotificationManager;
